export const MENU_CONSTANT = {
  CREATE_ROLE: "/role/create",
  ROLE_LIST: "/role/list",
  GET_ROLES: "/module/superadmin/get/module-permission-map",
  GET_DATA: "/role/get/config",
  ROLE_CHECK:"/role/check",
};
